module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-14.a96dd12f.png";